import { render } from "./Illustration.vue?vue&type=template&id=59d67aa9&scoped=true"
const script = {}

import "./Illustration.vue?vue&type=style&index=0&id=59d67aa9&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d67aa9"]])

export default __exports__